import React, { useContext } from "react";

import { HeaderBreadcrumb } from "../../../common/ui/layout/header/header-breadcrumb/HeaderBreadcrumb";
import { PageHeader } from "../../../common/ui/layout/header/PageHeader";
import { adminRoutes } from "../../AdminRoutes";
import { LanguageSpecificationDashboardContext } from "./context/LanguageSpecificationDashboardContext";

export const LanguageSpecificationDashboardHeader: React.FC = () => {
    const { isLoading, languageSpecificationDashboardItem } = useContext(LanguageSpecificationDashboardContext);

    const resolveLanguageSpecificationName = (pathPart: string) => {
        if (pathPart === ":languageSpecificationId") {
            return languageSpecificationDashboardItem.name;
        }

        return undefined;
    };

    return (
        <PageHeader>
            <HeaderBreadcrumb
                key={languageSpecificationDashboardItem.id}
                routes={adminRoutes}
                isLoading={isLoading}
                resolveCustomPathText={resolveLanguageSpecificationName}
            />
        </PageHeader>
    );
};
